import { OrderTemplate } from '../order-template.model';

export class OrderDetails {
  orderCode: string;
  name: string;
  orderingServiceCode: string;
  orderingServiceName: string;
  displayOrder: string;
  accountName: string;
  displayAccount: string;
  accountCode: string;
  status: string;
  orderPlacedOn: string;
  quotationCode: string;
  contractCode: string;
  receivingPartnerCode: string;
  salesPartnerCode: string;
  orderReference: string;
  customerReference: string;
  customerComment: string;
  eleCode: string;
  intercoEleCode: string;
  createdByName?: string;
  orderTemplate?: OrderTemplate;
  fromSchedule: boolean;

  // Used for Submitted Order Case to display create button
  canCreateOrder: boolean;
  constructor() { }
}
